
import React from 'react';

export const BenefitsSection: React.FC = () => {
  const benefits = [
    {
      icon: 'ri-home-4-line',
      title: '입주권 2채 확보 가능',
      description: '기존 대지 면적에 따라 최대 2채의 입주권 확보가 가능하며, 추가 분양 수익도 기대할 수 있습니다.',
      details: ['대지 면적별 입주권 배정', '잉여 세대 분양 수익 참여', '임대 수익 창출 가능']
    },
    {
      icon: 'ri-community-line',
      title: '주거환경 개선',
      description: '커뮤니티 시설, 공원, 주차장 등 생활 인프라가 대폭 개선되어 쾌적한 주거환경을 제공합니다.',
      details: ['커뮤니티 센터 및 휴게공간', '조경 및 공원 시설', '충분한 주차공간 확보']
    },
    {
      icon: 'ri-shield-check-line',
      title: '안전 품질 기준 상향',
      description: '내진 설계, 화재 안전, 주차 동선 개선 등 최신 건축 기준을 적용하여 안전성을 대폭 향상시킵니다.',
      details: ['내진 1등급 설계 적용', '화재 안전 시설 완비', '보행자 우선 동선 설계']
    },
    {
      icon: 'ri-map-pin-line',
      title: '지역 가치와 생활 편의',
      description: '강남권 중심 생활권 접근성과 함께 교통, 교육, 상업시설 등 생활 인프라가 확장됩니다.',
      details: ['대청역 접근성 개선', '교육시설 및 학군 혜택', '상업시설 및 편의시설 확충']
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            핵심 혜택
          </h2>
          <p className="text-lg text-gray-600">
            모아타운 참여로 얻을 수 있는 주요 혜택들을 확인해보세요
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mr-6 flex-shrink-0">
                  <i className={`${benefit.icon} text-xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {benefit.description}
                  </p>
                  <ul className="space-y-2">
                    {benefit.details.map((detail, detailIndex) => (
                      <li key={detailIndex} className="flex items-center text-sm text-gray-700">
                        <div className="w-1.5 h-1.5 bg-green-500 rounded-full mr-3"></div>
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
